import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button, message, Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import Fetch from '../../Fetch';
import { pop, push } from '../../component/link';

const Actions = props => {
    const [loading, setLoading] = React.useState(false);

    const onConfirm = async () => {
        setLoading(true);
        try {
            await Fetch.del(`/book/${props.dataId}`);
            message.info('Buku berhasil dihapus');
            if (props.reload !== undefined) {
                props.reload();
            } else {
                pop(props, '/book');
            }
        } catch (err) {
            message.error('Error: ' + err);
        }
    }

    return (
        <Button.Group>
            <Button icon="edit" href={`/book/${props.dataId}/edit`} onClick={(e) => {
                e.preventDefault();
                push(props, `/book/${props.dataId}/edit`);
            }}>Edit</Button>
            <Button icon="qrcode" onClick={props.printQr}>Print QR</Button>
            <Popconfirm placement="bottomLeft" title={"Yakin menghapus buku?"} onConfirm={onConfirm} okText="Iya" cancelText="Tidak">
                <Button icon="delete" type="danger" loading={loading}>Hapus</Button>
            </Popconfirm>
        </Button.Group >
    );
}

Actions.propTypes = {
    dataId: PropTypes.string.isRequired,
    reload: PropTypes.func,
}

export default withRouter(Actions);